<template>
  <LModal v-model:open="modalActive" @on-close-modal="hideModal">
    <template #content>
      <component :is="modalContent" />
    </template>
  </LModal>
</template>

<script setup lang="ts">
import { LModal } from '@wgg.hyve/hyve-ui-library'
import { computed } from 'vue'
import type { Component } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '@/stores/globalStore'
import AAssumptionOfInsuranceCosts from '@/components/atoms/modal-content/costs/A-AssumptionOfInsuranceCosts.vue'
import AEmployerSubsidy from '@/components/atoms/modal-content/employer/A-EmployerSubsidy.vue'
import AEmployerTaxDeduction from '@/components/atoms/modal-content/employer/A-EmployerTaxDeduction.vue'
import AMonthlySalary from '@/components/atoms/modal-content/monthly-salary/A-MonthlySalary.vue'
import APurchasePrice from '@/components/atoms/modal-content/price/A-PurchasePrice.vue'
import AUvpPrice from '@/components/atoms/modal-content/price/A-UvpPrice.vue'

const { modalActive: _modalActive, modalContentComponent } = storeToRefs(useGlobalStore())
const { hideModal } = useGlobalStore()

const modalActive = computed({
  get: () => _modalActive.value,
  set: (value: boolean) => {
    if (!value) hideModal()
  }
})

const MODALS: Record<string, Component | null> = {
  'A-AssumptionOfInsuranceCosts': AAssumptionOfInsuranceCosts,
  'A-EmployerSubsidy': AEmployerSubsidy,
  'A-EmployerTaxDeduction': AEmployerTaxDeduction,
  'A-MonthlySalary': AMonthlySalary,
  'A-PurchasePrice': APurchasePrice,
  'A-UvpPrice': AUvpPrice
}

const modalContent = computed<Component | null>(() => MODALS[modalContentComponent.value ?? ''] ?? null)
</script>

<style lang="scss">
// The modal is deliberately not scoped, otherwise this would lead to broken styling for modal content components
@use 'a-info-modal';
</style>
